module.exports = __webpack_public_path__ + "media/images/emblems/Selzach-blason-3e809704abee69c546436099e8db5524.png";